/* ============================================================
   LOW KEY AUTOMOTIVE - PRO DIESEL FITMENT FILTER v10
   Inferred storefront fitment for product titles, tags, types,
   and vendors. True fitment should still come from ACES/Turn14
   data when available.
   ============================================================ */

window.LKFilter = (function() {
  var OPEN_END_YEAR = 2038;

  var PLATFORM_TERMS = {
    duramax: /\b(duramax|lb7|lly|lbz|lmm|lml|l5p|lgh|lm2|lz0|gm diesel|chevy diesel|gmc diesel|chevrolet diesel|2\.8 diesel|2\.8l diesel|3\.0 diesel|3\.0l diesel|3\.0 duramax|3\.0l duramax|6\.6 diesel|6\.6l diesel|6\.6 duramax|6\.6l duramax|silverado 1500 diesel|sierra 1500 diesel|silverado 2500|silverado 3500|sierra 2500|sierra 3500|2500hd|3500hd|2500 hd|3500 hd)\b/,
    powerstroke: /\b(powerstroke|power stroke|ford diesel|f-150 diesel|f150 diesel|super duty diesel|super duty|f250|f350|f450|f550|f 250|f 350|f 450|f 550|f-250|f-350|f-450|f-550|3\.0 powerstroke|3\.0 power stroke|3\.0l powerstroke|3\.0l power stroke|7\.3 diesel|7\.3l diesel|6\.0 diesel|6\.0l diesel|6\.4 diesel|6\.4l diesel|6\.7 diesel|6\.7l diesel)\b/,
    cummins: /\b(cummins|ecodiesel|eco diesel|ram diesel|dodge diesel|ram 1500 diesel|dodge 1500 diesel|3\.0 ecodiesel|3\.0l ecodiesel|5\.9 diesel|5\.9l diesel|6\.7 diesel|6\.7l diesel|ram 2500|ram 3500|dodge 2500|dodge 3500|ram 4500|ram 5500)\b/
  };

  var UNIVERSAL_TERMS = /\b(universal|diesel|fuel filter|lift pump|water separator|fuel line|fuel hose|gauge|monitor|scan tool|adapter|fitting|hose|clamp|sensor|filter kit|drain plug)\b/;
  var MAKE_TERMS = /\b(chevy|chevrolet|gmc|gm|dodge|ram|ford|toyota|nissan|subaru|audi|jeep|mustang|camaro|corvette|charger|challenger|tundra|tacoma|4runner)\b/;
  var GAS_ONLY_TERMS = /\b(ignition coil|coil pack|spark plug|spark plugs|throttle body spacer|camaro|corvette|challenger|charger|hemi|ecoboost|godzilla|wrx|subaru|audi|toyota|tundra|tacoma|4runner|nissan|suzuki|mustang|5\.7 hemi|6\.4 hemi|jeep 3\.6|gas only)\b/;

  function normalize(s) {
    return String(s || '').toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[\u2012\u2013\u2014\u2015]/g, '-')
      .replace(/[()\[\]{}]/g, ' ')
      .replace(/_/g, ' ')
      .replace(/\bf[\s-]?(250|350|450|550)\b/g, 'f-$1')
      .replace(/power[\s-]?stroke/g, 'powerstroke')
      .replace(/[^a-z0-9.\-/+\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function searchableText(title, tags, type, vendor) {
    return normalize([
      title || '',
      Array.isArray(tags) ? tags.join(' ') : String(tags || ''),
      type || '',
      vendor || ''
    ].join(' '));
  }

  function yearNumber(token) {
    var raw = String(token || '').trim();
    var half = /\.5$/.test(raw) ? 0.5 : 0;
    var n = parseInt(raw.replace(/\.5$/, ''), 10);
    if (isNaN(n)) return null;
    if (n < 100) n = n < 35 ? 2000 + n : 1900 + n;
    return n + half;
  }

  function endYearNumber(startYear, token) {
    var raw = String(token || '').trim();
    var half = /\.5$/.test(raw) ? 0.5 : 0;
    var n = parseInt(raw.replace(/\.5$/, ''), 10);
    if (isNaN(n)) return null;
    if (n < 100 && startYear >= 1900) {
      var century = Math.floor(startYear / 100) * 100;
      n = century + n;
      if (n < startYear) n += 100;
    } else if (n < 100) {
      n = n < 35 ? 2000 + n : 1900 + n;
    }
    return n + half;
  }

  function parseYearRanges(text) {
    var t = normalize(text);
    var ranges = [];
    var seen = {};

    function push(startRaw, endRaw) {
      var start = yearNumber(startRaw);
      var end = endRaw === '+' ? OPEN_END_YEAR : endYearNumber(start, endRaw);
      if (start === null || end === null || end < start) return;
      if (start < 1980 || end > OPEN_END_YEAR) return;
      var key = start + '-' + end;
      if (!seen[key]) {
        seen[key] = true;
        ranges.push({ start: start, end: end });
      }
    }

    var m;
    var rangeRe = /\b((?:19|20)?\d{2}(?:\.5)?)\s*(?:-|to|through|thru)\s*((?:19|20)?\d{2}(?:\.5)?)\b/g;
    while ((m = rangeRe.exec(t))) {
      if (/^\d\.\d$/.test(m[1]) || /^\d\.\d$/.test(m[2])) continue;
      push(m[1], m[2]);
    }

    var plusRe = /\b((?:19|20)?\d{2}(?:\.5)?)\s*\+/g;
    while ((m = plusRe.exec(t))) push(m[1], '+');

    var singleYearRe = /\b(19[8-9]\d|20[0-3]\d)\b/g;
    while ((m = singleYearRe.exec(t))) push(m[1], m[1]);

    return ranges;
  }

  function selectedYearNumber(selectedYear) {
    var yr = parseInt(selectedYear, 10);
    return isNaN(yr) ? null : yr;
  }

  function yearCompatible(text, selectedYear) {
    var yr = selectedYearNumber(selectedYear);
    if (yr === null) return true;
    var ranges = parseYearRanges(text);
    if (!ranges.length) return true;
    return ranges.some(function(r) { return yr >= r.start && yr <= r.end; });
  }

  function selectedDuramaxCode(engine, year) {
    var e = normalize(engine);
    var yr = selectedYearNumber(year);
    if (/\blb7\b/.test(e)) return 'lb7';
    if (/\blly\b/.test(e)) return 'lly';
    if (/\blbz\b/.test(e)) return 'lbz';
    if (/\blmm\b/.test(e)) return 'lmm';
    if (/\blml\b/.test(e)) return 'lml';
    if (/\bl5p\b/.test(e)) return 'l5p';
    if (/\blgh\b|\b2\.8l?\b/.test(e)) return 'lgh';
    if (/\blm2\b|\blz0\b|\b3\.0l?\b/.test(e)) return 'd30';
    if (yr === null) return '';
    if (yr >= 2001 && yr <= 2004) return 'lb7';
    if (yr >= 2005 && yr <= 2005) return 'lly';
    if (yr >= 2006 && yr <= 2007) return 'lbz';
    if (yr >= 2008 && yr <= 2010) return 'lmm';
    if (yr >= 2011 && yr <= 2016) return 'lml';
    if (yr >= 2017) return 'l5p';
    return '';
  }

  function selectedPowerstrokeCode(engine, year) {
    var e = normalize(engine);
    var yr = selectedYearNumber(year);
    if (/\b7\.3\b/.test(e)) return '7.3';
    if (/\b6\.0\b/.test(e)) return '6.0';
    if (/\b6\.4\b/.test(e)) return '6.4';
    if (/\b6\.7\b/.test(e)) return '6.7';
    if (/\b3\.0l?\b/.test(e)) return '3.0';
    if (yr === null) return '';
    if (yr >= 1994 && yr <= 2003) return '7.3';
    if (yr >= 2004 && yr <= 2007) return '6.0';
    if (yr >= 2008 && yr <= 2010) return '6.4';
    if (yr >= 2011) return '6.7';
    return '';
  }

  function selectedCumminsCode(engine, year) {
    var e = normalize(engine);
    var yr = selectedYearNumber(year);
    if (/\becodiesel\b|\beco diesel\b|\b3\.0l?\b/.test(e)) return 'ecodiesel';
    if (/\b12v\b|12 valve/.test(e)) return '5.9-12v';
    if (/\b24v\b|24 valve/.test(e)) return '5.9-24v';
    if (/common rail|common-rail/.test(e) || /\b5\.9\b/.test(e)) return '5.9-cr';
    if (/\b6\.7\b/.test(e)) return '6.7';
    if (yr === null) return '';
    if (yr >= 1994 && yr <= 1998) return '5.9-12v';
    if (yr >= 1999 && yr <= 2002) return '5.9-24v';
    if (yr >= 2003 && yr <= 2007) return '5.9-cr';
    if (yr >= 2008) return '6.7';
    return '';
  }

  function vehiclePlatform(make, model, engine) {
    var m = normalize(make);
    var mdl = normalize(model);
    var e = normalize(engine);
    var vehicle = m + ' ' + mdl + ' ' + e;
    if (/\b(lb7|lly|lbz|lmm|lml|l5p|lgh|duramax|6\.6)\b/.test(e)) return 'duramax';
    if (/\becodiesel\b|\beco diesel\b/.test(e) && /\b(dodge|ram|1500)\b/.test(vehicle)) return 'cummins';
    if (/\b3\.0l?\b/.test(e) && /\b(dodge|ram)\b/.test(vehicle) && /\b1500\b/.test(vehicle)) return 'cummins';
    if (/\bcummins\b|\b5\.9\b|\b6\.7\b/.test(e) && /\b(dodge|ram|2500|3500|4500|5500)\b/.test(vehicle)) return 'cummins';
    if (/\b(powerstroke|7\.3|6\.0|6\.4|6\.7)\b/.test(e) && /\b(ford|f-250|f-350|f-450|f-550|super duty)\b/.test(vehicle)) return 'powerstroke';
    if (/\b(chevrolet|chevy|gmc)\b/.test(m) && /\b(silverado|sierra|2500|3500|hd)\b/.test(mdl)) return 'duramax';
    if (/\b(dodge|ram)\b/.test(m) && /\b(ram|2500|3500|4500|5500)\b/.test(mdl)) return 'cummins';
    if (/\bford\b/.test(m) && /\b(f-250|f-350|f-450|f-550|super duty)\b/.test(mdl)) return 'powerstroke';
    return '';
  }

  function textPlatform(text) {
    var t = normalize(text);
    if (/\b(lb7|lly|lbz|lmm|lml|l5p|lgh|duramax)\b/.test(t)) return 'duramax';
    if (/\b(chevy|chevrolet|gmc|gm)\b/.test(t) && /\b(6\.6|diesel|2500|3500|hd|silverado|sierra)\b/.test(t)) return 'duramax';
    if (/\becodiesel\b|\beco diesel\b/.test(t)) return 'cummins';
    if (/\b3\.0l?\b/.test(t) && /\b(ram|dodge)\b/.test(t)) return 'cummins';
    if (/\bcummins\b/.test(t) || (/\b(5\.9|6\.7)\b/.test(t) && /\b(ram|dodge)\b/.test(t))) return 'cummins';
    if (/\b(powerstroke|power stroke|super duty|f-250|f-350|f-450|f-550)\b/.test(t)) return 'powerstroke';
    if (/\b(7\.3|6\.0|6\.4|6\.7)l?\b/.test(t) && /\b(ford|f-250|f-350|f-450|f-550)\b/.test(t)) return 'powerstroke';
    return '';
  }

  function hasPlatformTerms(text, platform) {
    return !!(PLATFORM_TERMS[platform] && PLATFORM_TERMS[platform].test(normalize(text)));
  }

  function isLikelyGasOnly(text) {
    var t = normalize(text);
    if (!GAS_ONLY_TERMS.test(t)) return false;
    if (/\bjeep\b/.test(t) && /\bdiesel\b/.test(t)) return false;
    return true;
  }

  function titleHardRejectsVehicle(titleText, platform, make, model, engine, year) {
    var t = normalize(titleText);
    var selectedEngine = normalize(engine);
    var selectedIsThreeLiter = /\b3\.0l?\b/.test(selectedEngine);
    var selectedIsEcoDiesel = /\becodiesel\b|\beco diesel\b/.test(selectedEngine) || (platform === 'cummins' && selectedIsThreeLiter);
    if (!t) return false;

    if (platform === 'duramax' && /\b(ford|f-150|f-250|f-350|f-450|f-550|super duty|powerstroke|dodge|ram|cummins)\b/.test(t)) return true;
    if (platform === 'powerstroke' && /\b(chevy|chevrolet|gmc|silverado|sierra|duramax|dodge|ram|cummins)\b/.test(t)) return true;
    if (platform === 'cummins' && /\b(ford|f-150|f-250|f-350|f-450|f-550|super duty|powerstroke|chevy|chevrolet|gmc|silverado|sierra|duramax)\b/.test(t)) return true;

    if (platform === 'powerstroke') {
      if ((/\bf-150\b|\bf150\b/.test(t)) && !selectedIsThreeLiter) return true;
      if (/\bv\s*8\s*[-/]?\s*(5\.0|6\.2)\s*l?\b|\bv\s*10\b|\b5\.0l?\b|\b6\.2l?\b|\bgodzilla\b/.test(t)) return true;
    }

    if (platform === 'cummins') {
      if ((/\b1500\b/.test(t) && !selectedIsEcoDiesel) || /\bhemi\b/.test(t)) return true;
      if (/\bv\s*8\s*[-/]?\s*(5\.7|6\.4)\s*l?\b|\b5\.7l?\b|\b6\.4l?\b/.test(t)) return true;
    }

    if (platform === 'duramax') {
      if ((/\b1500\b/.test(t) && !selectedIsThreeLiter) || /\bv\s*8\s*[-/]?\s*(4\.8|5\.3|6\.0|6\.2)\s*l?\b|\b5\.3l?\b|\b6\.2l?\b/.test(t)) return true;
    }

    return false;
  }

  function productDuramaxCodes(text) {
    var t = normalize(text).replace(/[/-]/g, ' ');
    var codes = ['lb7', 'lly', 'lbz', 'lmm', 'lml', 'l5p', 'lgh'].filter(function(code) {
      return new RegExp('\\b' + code + '\\b').test(t);
    });
    if (/\blm2\b|\blz0\b|\b3\.0l? duramax\b|\b3\.0l? diesel\b/.test(t)) codes.push('d30');
    return codes;
  }

  function productPowerstrokeCodes(text) {
    var t = normalize(text);
    if (textPlatform(t) !== 'powerstroke') return [];
    return ['3.0', '7.3', '6.0', '6.4', '6.7'].filter(function(code) {
      return new RegExp('\\b' + code.replace('.', '\\.') + 'l?\\b').test(t);
    });
  }

  function productCumminsCodes(text) {
    var t = normalize(text);
    var codes = [];
    if (/\becodiesel\b|\beco diesel\b/.test(t) || (/\b3\.0l?\b/.test(t) && /\b(ram|dodge|1500)\b/.test(t))) codes.push('ecodiesel');
    if (/\b12v\b|12 valve/.test(t)) codes.push('5.9-12v');
    if (/\b24v\b|24 valve/.test(t)) codes.push('5.9-24v');
    if (/common rail|common-rail/.test(t) || (/\b5\.9\b/.test(t) && !codes.length)) codes.push('5.9-cr');
    if (/\b6\.7\b/.test(t)) codes.push('6.7');
    return codes;
  }

  function selectedCode(platform, engine, year) {
    if (platform === 'duramax') return selectedDuramaxCode(engine, year);
    if (platform === 'powerstroke') return selectedPowerstrokeCode(engine, year);
    if (platform === 'cummins') return selectedCumminsCode(engine, year);
    return '';
  }

  function productCodes(platform, text) {
    if (platform === 'duramax') return productDuramaxCodes(text);
    if (platform === 'powerstroke') return productPowerstrokeCodes(text);
    if (platform === 'cummins') return productCumminsCodes(text);
    return [];
  }

  function engineCompatible(text, platform, engine, year) {
    var t = normalize(text);
    var selected = selectedCode(platform, engine, year);
    var codes = productCodes(platform, t);
    if (codes.length && selected && codes.indexOf(selected) === -1) return false;

    if (platform === 'cummins') {
      if (selected === 'ecodiesel') {
        if (/\bcummins\b|\b5\.9\b|\b6\.7\b/.test(t)) return false;
        if (/\b2500\b|\b3500\b|\b4500\b|\b5500\b/.test(t) && !/\b1500\b/.test(t)) return false;
      } else if (/\becodiesel\b|\beco diesel\b/.test(t)) {
        return false;
      }
      if (selected === '6.7' && /\b5\.9\b/.test(t) && !/\b6\.7\b/.test(t)) return false;
      if (selected !== '6.7' && /\b6\.7\b/.test(t) && !/\b5\.9\b/.test(t)) return false;
    }

    if (platform === 'powerstroke') {
      var yr = selectedYearNumber(year);
      var ranges = parseYearRanges(t);
      if (selected === '6.7' && yr !== null && yr >= 2020 && ranges.length) {
        var fits2020 = ranges.some(function(r) { return 2020 >= r.start && 2020 <= r.end; });
        if (!fits2020) return false;
      }
    }

    return true;
  }

  function isUniversalPlatformPart(text, platform) {
    var t = normalize(text);
    if (!UNIVERSAL_TERMS.test(t)) return false;
    if (!hasPlatformTerms(t, platform)) return false;
    var p = textPlatform(t);
    if (p && p !== platform) return false;
    if (parseYearRanges(t).length) return false;
    return true;
  }

  function hasUsefulSpecificFitment(text, platform, year, engine) {
    var t = normalize(text);
    var ranges = parseYearRanges(t);
    var codes = productCodes(platform, t);
    if (ranges.length && !yearCompatible(t, year)) return false;
    if (!engineCompatible(t, platform, engine, year)) return false;
    if (codes.length) return true;
    if (ranges.length) return true;
    return false;
  }

  function productMatchesVehicle(title, tags, year, make, model, engine, type, vendor) {
    var titleText = searchableText(title, [], '', '');
    var text = searchableText(title, tags, type, vendor);
    var hasVehicleSelection = !!(year || make || model || engine);
    if (!hasVehicleSelection) return true;

    var platform = vehiclePlatform(make, model, engine);
    if (!platform) return false;
    if (titleHardRejectsVehicle(titleText, platform, make, model, engine, year)) return false;
    if (isLikelyGasOnly(text)) return false;
    if (!yearCompatible(text, year)) return false;

    var productPlatform = textPlatform(text);
    if (productPlatform && productPlatform !== platform) return false;
    if (!hasPlatformTerms(text, platform)) return false;
    if (!engineCompatible(titleText, platform, engine, year)) return false;
    if (!engineCompatible(text, platform, engine, year)) return false;

    if (hasUsefulSpecificFitment(text, platform, year, engine)) return true;
    return isUniversalPlatformPart(text, platform);
  }

  /*
    Internal matcher examples:
    - 2016 Chevrolet Silverado 2500HD 6.6L Duramax LML:
      pass "2011-2016 Chevy GMC Duramax LML Fuel Filter Kit"
      fail "2017-2022 Duramax L5P Intake"
    - 2021 Ford F-250 Super Duty 6.7L Power Stroke:
      pass "2020+ Ford 6.7 Powerstroke Fuel System Kit"
      fail "2011-2016 Ford 6.7 Powerstroke Intercooler Pipe"
    - 2018 Ram 2500 6.7L Cummins:
      pass "2013-2018 Ram 6.7 Cummins Lift Pump"
      fail "1998.5-2002 Dodge 5.9 24V Cummins Injector"
  */

  return {
    productMatchesVehicle: productMatchesVehicle,
    parseYearRanges: parseYearRanges,
    vehiclePlatform: vehiclePlatform,
    textPlatform: textPlatform,
    yearCompatible: yearCompatible
  };
})();
